import { setCookie, getCookie } from './shared/cookieHelper';

$(function () {
    var div_show = $('#showMe'),
        arrow = $('#arrow');
    div_show.css('display', 'none');
    arrow.css('display', 'none');

    var enablelo = "Y";
    if (enablelo == "Y") {
        var vCode = ' @ViewData["COOKAGENT"]';
        if (vCode == " " || vCode == null || vCode == "") {
            div_show.css('display', 'none');
            arrow.css('display', 'none');
        } else {
            var a = getCookie("lostate");
            if (a == " " || a == null || a == "") {
                setCookie("lostate", "open", 1);
                a = getCookie("lostate");
                arrow.css('display', 'none');
                div_show.css('display', 'block');
            } else {
                if (a == "open") {
                    arrow.css('display', 'none');
                    div_show.css('display', 'block');
                }
                if (a == "close") {
                    div_show.css('display', 'none');
                    arrow.css('display', 'block');
                }
            }
        }
    }
    else {
        div_show.css('display', 'none');
        arrow.css('display', 'none');
    }
    $('.expandContent').click(function () {
       setCookie("lostate", "open", 1);
        div_show.slideToggle('fast', function () {
            arrow.css('display', 'none');
        });
    });

    $('.bcClose').click(function () {
        setCookie("lostate", "close", 1);
        div_show.slideToggle('fast', function () {
            arrow.css('display', 'block');
        });
    }
    );
});
